import I18n from 'i18n-js';

import Markdown from '~/components/Markdown';

import styles from './LoginFooter.module.scss';

export function LoginFooter(): JSX.Element {
  return (
    <footer className={styles.container}>
      <Markdown className={styles.legals}>{I18n.t('MenuView_legals')}</Markdown>
    </footer>
  );
}
